module.exports = __webpack_public_path__ + "static/surveyincentive01-91e19f35222261d2dbf10eb7ac6d9704.svg";